import Typography from "@mui/material/Typography";
import PaidIcon from "@mui/icons-material/Paid";
import Button from "@mui/material/Button";
import { LoadingListEntityProfile } from "Explore/Components";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Empty, Tag } from "antd";
import styles from "./InstitutionAwards.module.scss";
import AwardItem from "Explore/Components/AwardItem";
import SortSelect, { SORT_TYPE } from "Explore/Components/SortSelect";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import useExploreInfo from "Hooks/useExploreInfo";
import { useState } from "react";
import useInfinityPagination from "Hooks/useInfinityPagination";
import { getInstitutionTopAwardedGrants } from "Explore/Services/Institution";
import InfinityPagination from "Explore/Components/Pagination/InfinityPagination";

const InstitutionAwards = ({ institution_id, selectedKeywords, sliderValue }) => {
  const { entity_id: institutionIdentifier } = useExploreInfo();
  const targetInstitutionId = institution_id || institutionIdentifier;
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 20,
  });
  const [showLoginSection, setShowLoginSection] = useState(false);
  const [grantsFilter, setGrantsFilter] = useState({
    orderBy: "amount_awarded",
    order: "desc",
  });
  const { data, currentMaxPage, hasNextPage, isLoading } =
    useInfinityPagination({
      fetchFunction: getInstitutionTopAwardedGrants,
      resultKey: "awards",
      page: pagination.page,
      filter: {
        id: targetInstitutionId,
        keywords: selectedKeywords,
        order_by: grantsFilter.orderBy,
        order: grantsFilter.order,
        fromYear: sliderValue[0],
        toYear: sliderValue[1],
      },
      rowsPerPage: pagination.rowsPerPage,
      setPagination,
      errCallback: (e) => {
        if (e?.response?.status === 401) {
          setShowLoginSection(true);
        }
      },
    });

  return (
    <div className={styles["institution-awards"]}>
      <SortSelect
        sortData={grantsFilter}
        setSortData={setGrantsFilter}
        hasOrderType
        loading={isLoading}
        sortType={SORT_TYPE.GRANT}
      />
      <LoadingListEntityProfile
        isLoading={isLoading}
        component={
          (data[pagination.page - 1] || []).length > 0 ? (
            (data[pagination.page - 1] || []).map((item, index) => {
              return <AwardItem data={item} key={index} />;
            })
          ) : showLoginSection ? (
            <LoginRequiredSection />
          ) : (
            <Empty description="No Award Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={false}
      />
      <InfinityPagination
        style={{ marginTop: "20px" }}
        currentMaxPage={currentMaxPage}
        pagination={pagination}
        setPagination={setPagination}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        sizeChanger
      />
    </div>
  );
};

export default InstitutionAwards;
